/** @format */

import React from 'react';
import CustomTextButtom from './CustomTextButton';

function BackTextButton({ ...props }) {
    const { callback, callbackParam, size } = props;
    return <CustomTextButtom callback={callback} callbackParam={callbackParam} label="general:common.back" size={size} />;
}

export default BackTextButton;
